module.exports = __webpack_public_path__ + "img/movie.c492f3f2.svg";